import { customerModel } from './customerModel'
import { routeModel } from './routeModel'
import { serviceVisitModel } from './serviceVisitModel'

export const calendarModelMapper = {
  mapServiceVisit: serviceVisitModel,
  mapRoute: routeModel,
  mapCustomer: customerModel,
}
